<template>
    <li>
        <div class="title"><span>カテゴリ</span></div>
        <div class="detail">

            <ul class="form_lv-select">

                <!----------------------------------------------
                    Lv1
                ------------------------------------------------->
                <li class="lv1 form_checkbox" v-for="(first_category,index) in categoryList" v-bind:key="index">
                    <input type="checkbox" :name="'edit-category-lv1' + (first_category.id)" class="" :id="'edit-category' + (first_category.id)" v-on:change="changeFirstCategory(first_category)" v-bind:checked="first_category.checked">
                    <label :for="'edit-category' + (first_category.id)" class="_heigh-light">
                        <div class="check-mark"><span></span></div>
                        <span>{{ first_category.name }}</span>
                    </label>
                    <!--Lv2-->
                    <ul class="lv2">

                        <li class="form_checkbox">
                            <input type="checkbox" :name="'edit-category-lv2-all' + (first_category.id)" class="" :id="'edit-category-lv2-all' + (first_category.id)" v-on:change="changeSecondCategoryALL(first_category)">
                            <label :for="'edit-category-lv2-all' + (first_category.id)">
                                <div class="check-mark"><span></span></div>
                                <span>ALL</span>
                            </label>
                        </li>

                        <li class="form_checkbox" v-for="(second_category, second_category_index) in first_category.second_categories" v-bind:key="second_category_index">
                            <input type="checkbox" :name="'edit-category-lv2' + (second_category.first_category_id)" class="" :id="'edit-category-lv2' + (second_category.id)" v-on:change="changeSecondCategory(second_category)" v-bind:checked="second_category.checked">
                            <label :for="'edit-category-lv2' + (second_category.id)" class="_heigh-light">
                                <div class="check-mark"><span></span></div>
                                <span>{{ second_category.name }}</span>
                            </label>

                            <!--Lv3-->
                            <ul class="lv3"  v-if="second_category.first_category_id == 1 && second_category.id != 8">
                                <li class="form_checkbox">
                                    <input type="checkbox" :name="'edit-category-apparel-lv3-all' + (second_category.id)" class="" :id="'edit-category-apparel-lv3-all' + (second_category.id)" v-on:change="changeThirdCategoryALL(second_category)">
                                    <label :for="'edit-category-apparel-lv3-all' + (second_category.id)">
                                        <div class="check-mark"><span></span></div>
                                        <span>ALL</span>
                                    </label>
                                </li>

                                <li class="form_checkbox" v-for="(third_category,third_category_index) in second_category.third_categories" :key="third_category_index">
                                    <input type="checkbox" :name="'edit-category-apparel-lv3' + (third_category.second_category_id)" class="" :id="'edit-category-apparel-lv3' + (third_category.id)" v-on:change="changeThirdCategory(third_category)" v-bind:checked="third_category.checked">
                                    <label :for="'edit-category-apparel-lv3' + (third_category.id)" class="_heigh-light">
                                        <div class="check-mark"><span></span></div>
                                        <span>{{ third_category.name }}</span>
                                    </label>
                                </li>

                            </ul><!--lv3-->

                        </li>

                    </ul><!--/.Apparel Lv2-->

                </li><!--/Apparel-->

            </ul><!--/.form_lv-select--->
            <span style="color: red" v-if="$store.state.register.errors.category">必須項目を入力してください</span>
        </div>
    </li>
</template>

<script>

    export default {
        data() {
            return {
            }
        },
        computed: {
            categoryList(){
                return this.$store.state.register.set.categories;
            },
        },
        mounted() {
            // 編集の場合
            if (this.$store.state.detail.set.brand.categories){
                // 第1階層
                for(var i in this.$store.state.register.set.categories) {
                    var first_category = this.$store.state.register.set.categories[i];

                    // 選択された地方データがあればcheckedをもたせる
                    if (this.$store.state.detail.set.brand.categories.some(detail_first_category => detail_first_category.first_id == first_category.id)) {
                        this.$store.state.register.set.categories[i].checked = true;
                        if (!this.$store.state.register.form.categoriyLv1.some(select_first_category => select_first_category.first_id == first_category.id)) {
                            this.$store.state.register.form.categoriyLv1.push(first_category);
                        }
                    }

                    var detail_second_categories = this.$store.state.detail.set.brand.categories.filter((category) => {
                        return (category.first_id == first_category.id);
                    });

                    if (first_category.id == 1) {
                         // second_idの重複をなくす
                        detail_second_categories = Array.from(
                            new Map(detail_second_categories.map((category) => [category.second_id, category])).values()
                        );
                    }

                    // 第2階層
                    for(var i in first_category.second_categories) {
                        var second_category = first_category.second_categories[i];

                        // 選択された県データがあればcheckedをもたせる
                        if (this.$store.state.detail.set.brand.categories.some(detail_second_category => detail_second_category.second_id == second_category.id)) {
                            first_category.second_categories[i].checked = true;
                            this.$store.state.register.form.categoriyLv2.push(second_category);

                            // 全てに選択されていた場合は、Allにチェックをつける
                            if (first_category.second_categories.length == detail_second_categories.length) {
                                var name = 'input[name=edit-category-lv2-all' + first_category.id +']';
                                $(name).prop('checked', true);
                            }
                        }

                        var detail_third_category_length = this.$store.state.detail.set.brand.categories.filter((category) => {
                            return (category.second_id == second_category.id);
                        }).length;

                        // 第3階層
                        for(var i in second_category.third_categories) {
                            var third_category = second_category.third_categories[i];

                            // 選択された地方データがあればcheckedをもたせる
                            if (this.$store.state.detail.set.brand.categories.some(detail_third_category => detail_third_category.third_id == third_category.id)) {
                                second_category.third_categories[i].checked = true;
                                this.$store.state.register.form.categoriyLv3.push(third_category);

                                // 全てに選択されていた場合は、Allにチェックをつける
                                if (second_category.third_categories.length == detail_third_category_length) {
                                    var name = 'input[name=edit-category-apparel-lv3-all' + second_category.id +']';
                                    $(name).prop('checked', true);
                                }
                            }
                        }
                    }
                }
            }
        },
        methods: {
            changeFirstCategory(first_category) {

                // 検索用の第二階層のデータをVuex格納
                var itemIndex = '';
                var itemCheck = true;

                this.$store.state.register.form.categoriyLv1.forEach(function(item, index){
                    if (item.id == first_category.id) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                });

                if (!itemCheck){
                    this.$store.state.register.form.categoriyLv1.splice(itemIndex, 1)
                } else {
                    this.$store.state.register.form.categoriyLv1.push(first_category)
                }
                var id = first_category.id;
                var name = 'input[name=edit-category-lv2' + id +']';
                var name_all = 'input[name=edit-category-lv2-all' + id +']';

                $(name).prop('checked', false);
                $(name_all).prop('checked', false);

                // 第一階層のチェックが外れた時にVuexの第三階層データとチェックを削除
                var first_category_id = first_category.id;
                var id = 'edit-category' + first_category_id;
                var check = document.getElementById(id).checked;

                if (!check) {
                    if (first_category .id == 1) {
                        this.$store.state.register.form.categoriyLv3 = [];
                    }
                    for(var i in first_category.second_categories) {
                        var second_category = first_category.second_categories[i];
                        var name_lv3 = 'input[name=edit-category-apparel-lv3' + second_category.id +']';
                        $(name_lv3).prop('checked', false);
                        var name_lv3_all = 'input[name=edit-category-apparel-lv3-all' + second_category.id +']';
                        $(name_lv3_all).prop('checked', false);
                    }
                }

                // 第一階層のチェックが外れた時にVuexの第二階層データを削除
                var second_categories = this.$store.state.register.form.categoriyLv2;
                var result = second_categories.filter((second_category) => {
                    return (second_category.first_category_id !== first_category.id);
                });
                this.$store.state.register.form.categoriyLv2 = result;
            },
            changeSecondCategory(second_category) {
                var id = second_category.id;
                var name = 'input[name=edit-category-apparel-lv3' + id +']';
                var name_all = 'input[name=edit-category-apparel-lv3-all' + id +']';
                $(name).prop('checked', false);
                $(name_all).prop('checked', false);

                // 検索用の第二階層のデータをVuex格納
                var itemIndex = '';
                var itemCheck = true;

                this.$store.state.register.form.categoriyLv2.forEach(function(item, index){
                    if (item.name == second_category.name && item.first_category_id == second_category.first_category_id) {
                        itemIndex = index;
                        itemCheck = false;
                    }
                }); 

                if (!itemCheck){
                    this.$store.state.register.form.categoriyLv2.splice(itemIndex, 1)
                } else {
                    this.$store.state.register.form.categoriyLv2.push(second_category)
                }

                // 第二階層のチェックが外れた時にVuexの第三階層データを削除
                var third_categories = this.$store.state.register.form.categoriyLv3;
                if (third_categories) {
                    var result = third_categories.filter((third_category) => {
                        return (third_category.second_category_id !== second_category.id);
                    });
                }
                this.$store.state.register.form.categoriyLv3 = result;

                // 全選択のチェックを外す
                var first_category_id = second_category.first_category_id;
                var id = 'edit-category-lv2-all' + first_category_id;
                var name = 'input[name=edit-category-lv2-all' + first_category_id +']';
                var check = document.getElementById(id).checked;

                if (check) {
                    $(name).prop('checked', false);
                }
            },
            changeThirdCategory(third_category) {
                // 検索用の第三階層のデータをVuex格納
                var itemIndex = '';
                var itemCheck = true;

                if (this.$store.state.register.form.categoriyLv3){
                    this.$store.state.register.form.categoriyLv3.forEach(function(item, index){
                        if (item.name == third_category.name && item.second_category_id == third_category.second_category_id) {
                            itemIndex = index;
                            itemCheck = false;
                        }
                    }); 
                }

                if (!itemCheck){
                    this.$store.state.register.form.categoriyLv3.splice(itemIndex, 1)
                } else {
                    this.$store.state.register.form.categoriyLv3.push(third_category)
                }

                // 全選択のチェックを外す
                var second_category_id = third_category.second_category_id;
                var id = 'edit-category-apparel-lv3-all' + second_category_id;

                var check = document.getElementById(id).checked;

                var id = third_category.second_category_id;
                var name = 'input[name=edit-category-apparel-lv3-all' + id +']';

                if (check) {
                    $(name).prop('checked', false);
                }
            },
            changeSecondCategoryALL(first_category) {
                var first_category_id = first_category.id;
                var id = 'edit-category-lv2-all' + first_category_id;
                var check = document.getElementById(id).checked;
                var first_category_id = first_category_id;
                var name = 'input[name=edit-category-lv2' + first_category_id +']';

                var arrayA = this.$store.state.register.form.categoriyLv2;
                var arrayB = first_category.second_categories;
                if (check) {
                    // 第二階層全て選択
                    this.$store.state.register.form.categoriyLv2 = [...new Set( [...arrayA, ...arrayB] )];
                    $(name).prop('checked', true);
                } else {
                    // 第二階層全て選択解除
                    this.$store.state.register.form.categoriyLv2 = arrayA.filter((second_category) => {
                        return (second_category.first_category_id !== first_category.id);
                    });

                    $(name).prop('checked', false);
                    for(var i in first_category.second_categories) {
                        var second_category = first_category.second_categories[i];
                        var name_lv3 = 'input[name=edit-category-apparel-lv3' + second_category.id +']';
                        $(name_lv3).prop('checked', false);
                        var name_lv3_all = 'input[name=edit-category-apparel-lv3-all' + second_category.id +']';
                        $(name_lv3_all).prop('checked', false);
                    }
                }
            },
            changeThirdCategoryALL(second_category) {
                var second_category_id = second_category.id;
                var id = 'edit-category-apparel-lv3-all' + second_category_id;
                var check = document.getElementById(id).checked;

                var name = 'input[name=edit-category-apparel-lv3' + second_category_id +']';
                var arrayA = this.$store.state.register.form.categoriyLv3;
                var arrayB = second_category.third_categories;
                if (check) {
                    // 第三階層全て選択
                    this.$store.state.register.form.categoriyLv3 = [...new Set( [...arrayA, ...arrayB] )];
                    $(name).prop('checked', true);
                } else {
                    // 第三階層全て選択解除
                    this.$store.state.register.form.categoriyLv3 = arrayA.filter((third_category) => {
                        return (third_category.second_category_id !== second_category.id);
                    });
                    $(name).prop('checked', false);
                }
            },
        }
    }
</script>